module.exports = __webpack_public_path__ + "img/pin-primary.2ecf59e.svg";